import { isArrayOfObjectEqual } from "../../utils/array-values.utils";
import { formActionTypes } from "./form.types";

const INITIAL_STATE = {
    formInfo: null,
    formType: null,
    formTemplate: null,
    formExpandSection: {},
    formValues: {},
    isLoading: false,
    isSaved: false,
    isFail: false,
    isComplete: true,
    isPay: null,
    isApprove: false,
    hasApprovalRight: false,
    errorMessage: null,
    formValidationErrors: null,
    windowHeight: null,
    editUUID: null,
    formEdit: false,
    isEditByFullForm: false,
    tableData: [],
    tableLatestData: {},
    tableLatestRows: [],
    editData: null,
    autoFillDataForm: null,
    isFetching: false,
    removeTableRow: [],
    formTotalValues: null,
    formChangedValues: null,
    selectedField: null,
    selectedFieldValue: null,
    formSideBarNav: [],
    formSideBarNavActiveItem: 0,
    formProgress: 0,
    valueEntredBlur: false
}

const formReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case formActionTypes.SET_EDIT_UUID:
            return {
                ...state,
                editUUID: action.payload
            }
        case formActionTypes.SET_EDIT_DATA:
            return {
                ...state,
                editData: action.payload
            }
        case formActionTypes.SET_AUTO_FILL_DATA_FORM:
            return {
                ...state,
                autoFillDataForm: action.payload
            }
        case formActionTypes.SET_FORM_TABLE_DATA:
            return {
                ...state,
                tableData: action.payload
            }
        case formActionTypes.SET_FORM_LATEST_DATA:
            return {
                ...state,
                tableLatestData: action.payload
            }
        case formActionTypes.SET_TABLE_LATEST_ROWS:
            return {
                ...state,
                tableLatestRows: action.payload ? [...action.payload] : []
            }
        case formActionTypes.SET_IS_FETCHING:
            return {
                ...state,
                isFetching: action.payload
            }
        case formActionTypes.SET_FORM_EXPAND_SECTION:
            const sectionTypeId = action.sectionTypeId;
            const isExpand = action.isExpand;

            if (isExpand) {
                return {
                    ...state,
                    formExpandSection: {
                        ...state.formExpandSection,
                        [sectionTypeId]: true
                    }
                }
            }

            return {
                ...state,
                formExpandSection: {
                    ...state.formExpandSection,
                    [sectionTypeId]: !state.formExpandSection[sectionTypeId]
                }
            }
        case formActionTypes.SET_FORM_TYPE:
            return {
                ...state,
                formType: action.payload
            }
        case formActionTypes.SET_FORM_INFO:
            return {
                ...state,
                formInfo: action.payload
            }
        case formActionTypes.SET_FORM_TEMPLATE:
            return {
                ...state,
                formTemplate: action.payload
            }
        case formActionTypes.SET_FORM_TEMPLATE_ENABLE_FIELD:
            // state.form.formTemplate.bodySections.paymentDetails.fieldItems[1].disabled = false;
            // const disabledField = state.form.formTemplate.bodySections.paymentDetails.fieldItems[1]
            return {
                ...state,
                formInfo: {
                    ...state.formInfo
                },
                // formTemplate: {
                //     ...state.formTemplate
                // }
                // formTemplate: {
                //     ...state.formTemplate
                //     // bodySections: {
                //     //     ...state.formTemplate.bodySections,
                //     //     paymentDetails:{
                //     //         ...state.formTemplate.bodySections.paymentDetails,
                //     //         fieldItems: [
                //     //             ...state.formTemplate.bodySections.paymentDetails.fieldItems,
                //     //             disabledField
                //     //         ]
                //     //     }
                //     // }
                // }
            }
        case formActionTypes.SET_FORM_EDIT:
            return {
                ...state,
                formEdit: action.payload
            }
        case formActionTypes.SUBMIT_FORM_START:
            return {
                ...state,
                isLoading: true
            }
        case formActionTypes.SUBMIT_FORM_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true
            }
        case formActionTypes.SUBMIT_FORM_FAILURE:
            return {
                ...state,
                isFail: true,
                isLoading: false,
                errorMessage: action.payload
            }
        case formActionTypes.GENERAL_ERROR_MESSAGE:
            return {
                ...state,
                isFail: true,
                isLoading: false,
                errorMessage: action.payload
            }

        case formActionTypes.COMPLETE_FORM_START:
            return {
                ...state,
                isComplete: true
            }
        case formActionTypes.COMPLETE_FORM_SUCCESS:
            return {
                ...state,
                isComplete: action.payload,
            }
        case formActionTypes.COMPLETE_FORM_FAILURE:
            return {
                ...state,
                isFail: true,
                isComplete: false,
                errorMessage: action.payload
            }
        case formActionTypes.PAY_FORM_START:
            return {
                ...state,
                isPay: "paid"
            }
        case formActionTypes.PAY_FORM_SUCCESS:
            return {
                ...state,
                isPay: action.payload,
            }
        case formActionTypes.PAY_FORM_FAILURE:
            return {
                ...state,
                isFail: true,
                isPay: false,
                errorMessage: action.payload
            }
        case formActionTypes.APPROVE_FORM_START:
            return {
                ...state,
                isPay: "paid"
            }
        case formActionTypes.APPROVE_FORM_SUCCESS:
            return {
                ...state,
                isApprove: action.payload.isApprove,
                hasApprovalRight: action.payload.hasApprovalRight
            }
        case formActionTypes.APPROVE_FORM_FAILURE:
            return {
                ...state,
                isFail: true,
                isApprove: false,
                hasApprovalRight: false,
                errorMessage: action.payload
            }
        case formActionTypes.SET_IS_FAIL:
            return {
                ...state,
                isFail: false,
                errorMessage: action.payload
            }
        case formActionTypes.RESET_ERROR_MESSAGE_AND_IS_FAIL:
            return {
                ...state,
                errorMessage: null,
                isFail: false
            }
        case formActionTypes.SET_FORM_VALIDATION_ERROR:
            return {
                ...state,
                formValidationErrors: action.payload
            }
        case formActionTypes.SET_WINDOW_HEIGHT:
            return {
                ...state,
                windowHeight: action.payload
            }
        case formActionTypes.ADD_ROW_FORM_TABLE:
            const newTableDate = state.tableData.push(state.tableData[0]);

            return {
                ...state,
                tableData: newTableDate
            }
        case formActionTypes.REMOVE_ROW_FORM_TABLE:
            return {
                ...state,
                removeTableRow: action.payload
            }
        case formActionTypes.SET_FORM_TOTAL_VALUES:
            return {
                ...state,
                formTotalValues: action.payload
            }
        case formActionTypes.SET_FORM_CHANGED_VALUES:
            return {
                ...state,
                formChangedValues: action.payload
            }
        case formActionTypes.SET_IS_EDIT_FULL_FORM:
            return {
                ...state,
                isEditByFullForm: action.payload
            }
        case formActionTypes.SET_SELECTED_FIELD:
            return {
                ...state,
                selectedField: action.payload
            }
        case formActionTypes.SET_SELECTED_FIELD_VALUE:
            return {
                ...state,
                selectedFieldValue: action.payload
            }
        case formActionTypes.SET_FORM_SIDE_BAR_NAV:
            return {
                ...state,
                formSideBarNav: action.payload
            }
        case formActionTypes.SET_FORM_SIDE_BAR_NAV_ACTIVE_ITEM:
            return {
                ...state,
                formSideBarNavActiveItem: action.payload
            }
        case formActionTypes.SET_FORM_PROGRESS:
            return {
                ...state,
                formProgress: action.payload
            }
        case formActionTypes.SET_REMOVE_REMOVE_TABLE_ROW:
            return {
                ...state,
                removeTableRow: []
            }
        case formActionTypes.SET_VALUE_ENTERED_BLUR:
            return {
                ...state,
                valueEntredBlur: action.payload
            }
        default:
            return state;
    }
}

export default formReducer;